import { useQuery, useMutation } from '@tanstack/react-query';
import API_URL from '../config';

const getAuthHeader = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export function useAnnounceUsers() {
  return useQuery({
    queryKey: ['announce-users'],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/api/email/announce/users`, {
        headers: getAuthHeader(),
      });
      if (!res.ok) throw new Error('Failed to fetch users');
      const json = await res.json();
      return json.data;
    },
    staleTime: 60000,
  });
}

export function useSendAnnouncement() {
  return useMutation({
    mutationFn: async ({ recipientIds, subject, htmlBody, sendAt }) => {
      const res = await fetch(`${API_URL}/api/email/announce`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify({ recipientIds, subject, htmlBody, sendAt: sendAt || null }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.error || 'Failed to send announcement');
      return json.data;
    },
  });
}
